<template>
  <div>
    <app-header></app-header>
    <slot></slot>
  </div>
</template>
<script>
import Header from '@/components/projects/Header'
// import index from './../projects/index'
export default {
  name: 'dashboard',
  components: {
    appHeader: Header
  },
  mounted () {
    $('body').removeClass('bg-white')
  },
  beforeCreate () {
    if (localStorage.locale) this.$i18n.locale = localStorage.locale
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/dashboard.vue